import { ComponentHeader } from '@/catalog-apps/components/component-library/shared/ComponentHeader'
import { SearchInput } from '@/catalog-apps/components/component-library/shared/SearchInput'
import { ScrollArea } from '@/components/shadcn/scroll-area'
import { NoSearchResultsDisplay } from '@/components/ui/NoSeachResultsDisplay'
import { useRestClient } from '@/contexts/QueryProvider'
import clsx from 'clsx'
import { AnimatePresence } from 'motion/react'
import { useMemo, useState } from 'react'
import { Link } from 'react-router'
import { AppCard } from '../Homepage/AppCard'
import { Skeleton } from '@fluentui/react-components'

export function FeaturedAppsGrid() {
  const [searchString, setSearchString] = useState<string>('')
  const { getLandingApiGetApplicationExternal } = useRestClient()
  const { data: apps } = getLandingApiGetApplicationExternal.useSuspenseQuery(undefined)

  const filteredAppsIds = useMemo(
    () =>
      apps
        .filter((app) => {
          if (!searchString) return true
          const titleMatch = app.card.title.toLowerCase().includes(searchString.toLowerCase())
          const subtitleMatch = app.card.subtitle.toLowerCase().includes(searchString.toLowerCase())
          // const descriptionMatch = app.card.description.toLowerCase().includes(searchString.toLowerCase())
          return titleMatch || subtitleMatch
        })
        .map((app) => app.app_id),
    [apps, searchString]
  )

  return (
    <ScrollArea className="h-full">
      <div className="border-offwhite bg-offwhite/80 sticky top-0 z-10 flex w-full justify-between border-b backdrop-blur-sm">
        <ComponentHeader className="border-b-0 pt-5">
          <div className="ml-auto mr-0 flex items-center gap-4">
            <div className="flex items-center gap-x-2">
              <SearchInput value={searchString} onChange={setSearchString} />
            </div>
          </div>
        </ComponentHeader>
      </div>
      <AnimatePresence>
        {filteredAppsIds.length > 0 ? (
          <div className="grid w-full grid-cols-[repeat(auto-fill,minmax(450px,1fr))] gap-8 pb-5">
            {apps.map((app) => (
              <Link
                className={clsx(
                  'group block h-full w-full transition-all duration-300',
                  filteredAppsIds.includes(app.app_id) ? '' : 'hidden'
                )}
                to={`/featured-apps/${app.app_id}`}
                key={app.app_id}
              >
                <AppCard app={app} />
              </Link>
            ))}
          </div>
        ) : (
          <NoSearchResultsDisplay />
        )}
      </AnimatePresence>
    </ScrollArea>
  )
}

export function FeaturedAppsGridLoading() {
  return (
    <>
      <ComponentHeader className="border-b-0 pt-5">
        <div className="ml-auto mr-0 flex items-center gap-4">
          <div className="flex items-center gap-x-2">
            <Skeleton className="h-[35px] w-[150px]" />
          </div>
        </div>
      </ComponentHeader>
      <div className="grid w-full grid-cols-[repeat(auto-fill,minmax(450px,1fr))] gap-8 pb-5">
        {Array.from({ length: 10 }).map((_, index) => (
          <Skeleton key={index} className="h-[192px] w-full" />
        ))}
      </div>
    </>
  )
}
